import { useHistory } from 'react-router-dom'
import useComponentDidMount from '../../hooks/use-component-did-mount'

interface Props {
  message: string
}

/**
 * @date   2025-05-13
 * @author 새날_방용환
 * @desc   props로 전달 된 message 표출 후 이전 페이지로 이동
 */
const ErrorBoundaryFallbackReturn = (props: Props) => {
  const history  = useHistory()

  useComponentDidMount(() => {
    alert(props.message)
    history.goBack();
  })

  return <></>
}

export default ErrorBoundaryFallbackReturn
